import {sequence, trigger, stagger, animate, style, group, query, transition, keyframes, animateChild, state} from '@angular/animations';

export const detailExpand = trigger('detailExpand', [
        state('collapsed', style({height: '0px', minHeight: '0', display: 'none'})),
        state('expanded', style({height: '*'})),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]
);

export const routerTransition = trigger('routerTransition', [
    transition('* => *', [
        query(':enter, :leave', style({ position: 'fixed', width: 'calc(100% - 30px)', height: '100%'}), {optional: true}),
        query(':enter', style({ opacity: 0 }), {optional: true}),

        group([
            query(':leave', [
                style({ transform: 'translateX(0%)' }),
                animate('0.2s ease-in-out', style({ opacity: 0 }))
            ], {optional: true}),
            query(':enter', [
                animate('0.2s ease-in-out', style({ opacity: 1 }))
            ], {optional: true})
        ]),
    ]),
]);

export const flyInOut = trigger('flyInOut', [
    transition('* => *', [

        query(':enter', style({ opacity: 0 }), {optional: true}),

        query(':enter', stagger('0ms', [
          animate('.6s ease-in', keyframes([
            style({opacity: 0, transform: 'translateY(-75%)', offset: 0}),
            style({opacity: .75, transform: 'translateY(15px)',  offset: 0.3}),
            style({opacity: 1, transform: 'translateY(0)',     offset: 1.0}),
          ]))]), {optional: true})
          ,
        query(':leave', stagger('0ms', [
          animate('.6s ease-out', keyframes([
            style({opacity: 1, transform: 'translateY(0)', offset: 0}),
            style({opacity: .75, transform: 'translateY(15px)',  offset: 0.3}),
            style({opacity: 0, transform: 'translateY(-75%)',     offset: 1.0}),
          ]))]), {optional: true})
    ])
]);

export const reverseFlyInOut = trigger('reverseFlyInOut', [
    transition('* => *', [

        query(':enter', style({ opacity: 0 }), {optional: true}),

        query(':enter', stagger('0ms', [
          animate('.6s ease-in', keyframes([
            style({opacity: 0, transform: 'translateY(75%)', offset: 0}),
            style({opacity: .75, transform: 'translateY(-15px)',  offset: 0.3}),
            style({opacity: 1, transform: 'translateY(0)',     offset: 1.0}),
          ]))]), {optional: true})
          ,
        query(':leave', stagger('0ms', [
          animate('.6s ease-out', keyframes([
            style({opacity: 1, transform: 'translateY(0)', offset: 0}),
            style({opacity: .75, transform: 'translateY(-15px)',  offset: 0.3}),
            style({opacity: 0, transform: 'translateY(75%)',     offset: 1.0}),
          ]))]), {optional: true})
    ])
]);


export const focusInOut = trigger('focusInOut', [
    transition('* => *', animate('1000ms ease', keyframes([
        style({transform: 'scale(0.75)', offset: 0}),
        style({transform: 'scale(1.5)', offset: 0.3}),
        style({transform: 'scale(1)',  offset: 0.7}),
    ]))),
]);


export const rowsAnimation = trigger('rowsAnimation', [
    transition('* => *', [
        query(':leave', style({ opacity: 1 }), {optional: true}),
        query(':leave', stagger('100ms', [
            animate('.5s ease-in-out', keyframes([
                style({opacity: 1, transform: 'translateY(0)', offset: 0}),
                style({opacity: 0, transform: 'translateY(-15%)', offset: 1}),
            ]))]), {optional: true}
        ),
        query(':enter', style({ opacity: 0 }), {optional: true}),
        query(':enter', stagger('100ms', [
            animate('.5s ease-in-out', keyframes([
                style({opacity: 0, transform: 'translateY(-15%)', offset: 0}),
                style({opacity: 1, transform: 'translateY(0)', offset: 1}),
            ]))]), {optional: true}
        )
    ])
]);



export const rowCardsAnimation = trigger('rowCardsAnimation', [
    transition('* => *', [
        query(':leave', style({
            height: '*',
            width: '*',
            'flex-grow': '*',
            'flex-shrink': '*',
            'flex-basis': '*',
            paddingTop: '*',
            paddingBottom: '*',
            paddingLeft: '*',
            paddingRight: '*',
            opacity: 1,
            transform: 'translateX(0)'
        }), {optional: true}),
        query(':leave', stagger('100ms', [
            animate('.5s ease-in-out', keyframes([
                style({
                    opacity: 1,
                    transform: 'translateX(0)',
                    offset: 0
                }),
                style({
                    height: '*',
                    transform: 'translateX(-75px)',
                    opacity: 0,
                    'box-shadow': 'none',
                    offset: .5
                }),
                style({
                    height: 0,
                    width: 0,
                    'flex-grow': 0,
                    'flex-shrink': 0,
                    'flex-basis': 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0,
                    opacity: 0,
                    'box-shadow': 'none',
                    offset: 1
                }),
            ]))]), {optional: true}
        ),
        query(':enter', style({ opacity: 0 }), {optional: true}),
        query(':enter', stagger('100ms', [
            animate('.5s ease-in-out', keyframes([
                style({opacity: 0, height: '*', offset: 0}),
                style({opacity: 0, transform: 'translateY(-15%)', offset: .5}),
                style({opacity: 1, transform: 'translateY(0)', offset: 1}),
            ]))]), {optional: true}
        )
    ])
]);


export const foldersAnimation = trigger('foldersAnimation', [
    transition('* => *', [
        query(':enter', style({ opacity: 0 }), {optional: true}),
        query(':enter', stagger('100ms', [
            animate('.5s ease-in-out', keyframes([
                style({opacity: 0, transform: 'translateY(-15%)', offset: 0}),
                style({opacity: 1, transform: 'translateY(0)', offset: 1}),
            ]))]), {optional: true}
        )
    ])
]);

export const slideFromLeft = trigger('slideFromLeft', [
    transition('void => *', [
        style({ height: 0,  opacity: '0', transform: 'translateX(-75px)', 'box-shadow': 'none' }),
        sequence([
            animate('.25s ease', style({ height: '*', opacity: .5, transform: 'translateX(0)', 'box-shadow': 'none'  })),
            animate('.25s ease', style({ height: '*', opacity: 1, transform: 'translateX(0)' }))
        ])
    ]),
]);


export const fadeInOut = trigger('fadeInOut', [
    transition('void => *', [
        style({
            height: 0,
            opacity: '0',
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
        }),
        sequence([
            animate('1s ease', style({
                height: '*',
                opacity: 1,
                paddingTop: '*',
                paddingBottom: '*',
                paddingLeft: '*',
                paddingRight: '*',
                overflow: 'hidden'
            }))
        ])
    ]),
    transition('* => void', [
        style({
            height: '*',
            opacity: '1',
            paddingTop: '*',
            paddingBottom: '*',
            paddingLeft: '*',
            paddingRight: '*',
        }),
        sequence([
            animate('1s ease', style({
                height: 0,
                opacity: 0,
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                paddingRight: 0,
                overflow: 'hidden'
            })),
        ])
    ])
]);


export const quickOut = trigger('quickOut', [
    transition('* => void', [
        style({ opacity: '*', transform: 'translateY(0)', 'box-shadow': 'none', position: 'absolute' }),
        sequence([
            animate('.3s ease', style({ opacity: 0, backgroundColor: '#fff', transform: 'translateY(50%)', 'box-shadow': 'none', position: 'absolute' }))
        ])
    ])
]);


export const progressBar = trigger('progressBar', [
    transition('* => *', [
        style({ opacity: '1' }),
        sequence([
            animate('1s ease', style({ opacity: '1' }))
        ])
    ])
]);


export const slideInOut = trigger('slideInOut', [
    state('in', style({
        height: '*',
        width: '*',
        opacity: 1,
        overflow: 'hidden',
        display: 'block',
        transform: 'translateY(0)'
    })),
    state('out', style({
        height: 0,
        width: 0,
        opacity: 0,
        display: 'none',
        overflow: 'hidden',
        transform: 'translateY(-50px)'
    })),
    transition('in => out', animate('400ms ease-in-out')),
    transition('out => in', animate('400ms ease-in-out'))
]);


export const showInOut = trigger('showInOut', [
    state('in', style({
        width: '*',
        flex: '*',
        padding: '*',
        height: '*',
        opacity: 1,
        overflow: 'hidden',
        visibility: 'visible'
    })),
    state('out', style({
        width: 0,
        flex: 0,
        padding: 0,
        height: 0,
        opacity: 0,
        overflow: 'hidden',
        visibility: 'hidden'
    })),
    transition('in => out', animate('400ms ease-in-out')),
    transition('out => in', animate('400ms ease-in-out'))
]);

export const toggleShow = trigger('toggleShow', [
    transition('* => void', [
        style({
            width: '*',
            flex: '*',
            padding: '*',
            height: '*',
            opacity: 1,
            overflow: 'hidden',
         }),
        sequence([
            animate('400ms ease-in'),
        ])
    ]),
    transition('void => *', [
        style({
            width: 0,
            flex: 0,
            padding: 0,
            height: 0,
            opacity: 0,
            overflow: 'hidden',
         }),
        sequence([
            animate('400ms ease-in'),
        ])
    ])
]);

export const addAndRemove = trigger('addAndRemove', [
    transition('* => void', [
        style({ height: '*', opacity: '1', transform: 'translateX(0)', 'box-shadow': '0 1px 4px 0 rgba(0, 0, 0, 0.3)'}),
        sequence([
          animate('.25s ease', style({ height: '*', opacity: '.2', transform: 'translateX(20px)', 'box-shadow': 'none'  })),
          animate('.1s ease', style({ height: '0', opacity: 0, transform: 'translateX(20px)', 'box-shadow': 'none'  }))
        ])
    ]),
    transition('void => active', [
        style({ height: '0', opacity: '0', transform: 'translateX(20px)', 'box-shadow': 'none' }),
        sequence([
            animate('.1s ease', style({ height: '*', opacity: '.2', transform: 'translateX(20px)', 'box-shadow': 'none'  })),
            animate('.35s ease', style({ height: '*', opacity: 1, transform: 'translateX(0)', 'box-shadow': '0 1px 4px 0 rgba(0, 0, 0, 0.3)'  }))
        ])
    ])
]);

export const cardsAnimation = trigger('cardsAnimation', [
    transition('void => *', [
        style({
            opacity: 0,
            width: 0,
            transform: 'translateX(-75px)'
        }),
        sequence([
            animate('.35s ease', style({ opacity: 1, transform: 'translateX(0)', width: '*', overflow: 'hidden' }))
        ])
    ]),
    transition('* => void', [
        style({
            opacity: 1,
            width: '*',
            transform: 'translateX(0)'
        }),
        sequence([
            animate('.35s ease', style({ opacity: 0, transform: 'translateX(-75px)', width: 0, overflow: 'hidden' })),
        ])
    ])
]);


export const imgCardDrop = trigger('imgCardDrop', [
    transition('* => *', [
        query(':enter', style({ opacity: 0 }), {optional: true}),

        query(':enter', stagger('100ms', [
            animate('.5s ease-in-out', keyframes([
                style({opacity: 0, transform: 'translateY(-15%)', offset: 0}),
                style({opacity: 1, transform: 'translateY(0)', offset: 1.0}),
            ]))]), {optional: true}
        )
    ])
]);

export const imgCardDropFast = trigger('imgCardDropFast', [
    transition('* => *', [
        query(':enter', style({ opacity: 0 }), {optional: true}),

        query(':enter', stagger('100ms', [
            animate('.5s ease-in-out', keyframes([
                style({opacity: 0, transform: 'translateY(-15%)', offset: 0}),
                style({opacity: 1, transform: 'translateY(0)', offset: 1.0}),
            ]))]), {optional: true}
        )
    ])
]);
